import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2bc3a22c")

_pushScopeId("data-v-2bc3a22c")
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "reminder" }
const _hoisted_3 = { class: "trend-chart clearfix" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "name fl" }, "趋势", -1)
const _hoisted_5 = { class: "bluebox fl" }
const _hoisted_6 = { class: "greybox fl" }
const _hoisted_7 = { class: "orangebox fl" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "codetxt" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, "评估指标汇总")
], -1)
const _hoisted_9 = { class: "tb" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "检测指标"),
  /*#__PURE__*/_createVNode("div", null, "检测结果"),
  /*#__PURE__*/_createVNode("div", null, "提示"),
  /*#__PURE__*/_createVNode("div", null, "参考范围")
], -1)
const _hoisted_11 = { class: "item-pot" }
const _hoisted_12 = { class: "scorebox" }
const _hoisted_13 = { class: "score-item" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "最高", -1)
const _hoisted_15 = { class: "score-item" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "平均", -1)
const _hoisted_17 = { class: "score-item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, "最低", -1)
const _hoisted_19 = {
  key: 0,
  class: "item-pot"
}
const _hoisted_20 = {
  key: 1,
  class: "item-pot"
}
const _hoisted_21 = {
  key: 0,
  class: "item-pot"
}
const _hoisted_22 = {
  key: 1,
  class: "item-pot"
}
const _hoisted_23 = {
  key: 2,
  class: "item-pot"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "codetxt" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果汇总")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item, i) => {
    return (_openBlock(), _createBlock("div", {
      class: "card card-shadow",
      key: item.id
    }, [
      _createVNode("div", _hoisted_1, _toDisplayString(item.name + '测评'), 1),
      _createVNode("div", _hoisted_2, "温馨提示：" + _toDisplayString(item.msg), 1),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_van_icon, {
            name: "upgrade",
            class: "good"
          }),
          false
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "upgrade",
                class: "bed"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          false
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "upgrade",
                class: "good"
              }))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                name: "upgrade",
                class: "bed"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          false
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "upgrade",
                class: "good"
              }))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                name: "upgrade",
                class: "bed"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", {
        class: "ecarts-box echart-line-box",
        id: 'echart-line-box' +  i + _ctx.dayLength
      }, null, 8, ["id"]),
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.codeList, (code, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "itme result-num-box",
            key: index
          }, [
            _createVNode("div", _hoisted_11, _toDisplayString(code.name), 1),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", null, _toDisplayString(code.maxRange), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", null, _toDisplayString(code.avgValue), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", null, _toDisplayString(code.minValue), 1)
              ])
            ]),
            _createVNode("div", null, [
              (code.result === 1)
                ? (_openBlock(), _createBlock("div", _hoisted_19, "↑"))
                : _createCommentVNode("", true),
              (code.result === -1)
                ? (_openBlock(), _createBlock("div", _hoisted_20, "↓"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", null, [
              (!code.maxRange)
                ? (_openBlock(), _createBlock("div", _hoisted_21, "≥" + _toDisplayString(code.minRange), 1))
                : (!code.minRange)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, "≤" + _toDisplayString(code.maxRange), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(code.minRange) + "~" + _toDisplayString(code.maxRange), 1))
            ])
          ]))
        }), 128))
      ]),
      _hoisted_24,
      _createVNode("div", {
        class: "ecarts-box echart-pie-box",
        id: 'echart-pie-box' +  i + _ctx.dayLength
      }, null, 8, ["id"])
    ]))
  }), 128))
})